import type { ChatParams } from '@/contexts/chat/scripts/hooks/useChats/types';
import { ChatCategory, type Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import { msgExpireDurationOptions, msgExpireDurationIcon } from '@/configs/options';
import { chatApis } from '@/configs/apis/chat';
import { groupsApis } from '@/configs/apis/groups';
import styles from './index.module.scss';

interface ExpireTimeProps {
  chat: Chat;
  updateChats: (chats: ChatParams[]) => Promise<void>;
}

export default function ExpireTime({ chat, updateChats }: ExpireTimeProps) {
  const option = useMemo(() => {
    const opt = msgExpireDurationOptions.findByValue(chat.expire_duration);
    return {
      selectedKeys: [opt?.key || 'week'],
      icon: opt?.icon || msgExpireDurationIcon,
    };
  }, [chat.expire_duration]);

  return (
    <Dropdown
      overlayClassName={styles.expireTimeDropdown}
      placement="top"
      arrow
      menu={{
        selectable: true,
        selectedKeys: option.selectedKeys,
        items: msgExpireDurationOptions,
        async onSelect({ key }) {
          const expire_duration = msgExpireDurationOptions.findValue(key)!;
          if (chat.category === ChatCategory.SINGLE) {
            await chatApis.setChatInfo({
              chat_id: chat.chat_id,
              expire_duration,
            });
          } else {
            await groupsApis.updateGroupSettings({
              gid: chat.chat_id,
              expire_duration,
            });
          }
          await updateChats([
            {
              chat_id: chat.chat_id,
              expire_duration,
            },
          ]);
        },
      }}
    >
      <div>{option.icon}</div>
    </Dropdown>
  );
}
